import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../IconButton/IconButton';

var SliderArrow = function SliderArrow(_ref) {
  var dataHook = _ref.dataHook,
      _ref$arrowSize = _ref.arrowSize,
      arrowSize = _ref$arrowSize === void 0 ? 'medium' : _ref$arrowSize,
      buttonSkin = _ref.buttonSkin,
      icon = _ref.icon,
      className = _ref.className,
      remainingProps = _objectWithoutProperties(_ref, ["dataHook", "arrowSize", "buttonSkin", "icon", "className"]);

  var isDisabled = className.includes('slick-disabled');
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    "data-hook": dataHook,
    className: className
  }), /*#__PURE__*/React.createElement(IconButton, {
    skin: buttonSkin,
    size: arrowSize,
    disabled: isDisabled,
    priority: "secondary"
  }, icon));
};

SliderArrow.propTypes = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Icon to be rendered within the icon button */
  icon: PropTypes.element.isRequired
};
export default SliderArrow;